module.exports = __webpack_public_path__ + "img/telegram.99c2f06d.svg";